<template>
    <div>
        <div class="detail">
            <div class="featured-image" :style="{ backgroundImage: 'url(' + encodeUrlForCss(data.featured_image) + ')' }">
                <img :src="data.bot_character_image_url" class="bot-character" />
            </div>
            <div class="description">{{ data.description }}</div>
        </div>
        <div class="objective">
            <h3>{{ $t("homework.scenarios.objectives") }}</h3>
            <ul>
                <li class="goal" v-for="(objective, idx) in data.objectives" :key="idx">{{ (idx + 1) + ". " + objective }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
        }
    },
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    methods: {
      encodeUrlForCss(url) {
        return url.replace(/["'(),]/g, function(match) {
            return '%' + match.charCodeAt(0).toString(16);
        });
      }
    },
}
</script>

<style scoped lang="scss">
.detail {
  display: flex;
  gap: 16px;
  width: 566px;
  align-items: center;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #121131;
  .featured-image {
    position: relative;
    min-width: 150px;
    width: 150px;
    height: 90px;
    background-size: cover;
    background-position: center;
    border-radius: 8px;
    .bot-character {
        position: absolute;
        width: 38px; // Adjust if necessary
        height: 65px; // Adjust if necessary
        bottom: 0; // Adjust if necessary
        left: 40%; // Center horizontally
    }
}
  .description {
    font-weight: 400;
    white-space: break-spaces;
  }
}
.objective {
//   line-height: 24px;
  letter-spacing: 0.25px;
  color: #121131;
  margin-top: 16px;
  h3 {
    font-weight: 600;
    font-size: 14px;
    text-transform: capitalize;
  }
  ul {
    list-style: none; /* Remove default list styling */
    padding-left: 0; /* Remove default padding */
    margin: 0; /* Remove default margin */
  }
  li.goal {
    margin-bottom: 10px;
    font-weight: 400;
    font-size: 12px;
  }
}

</style>
